import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as marketplaceDemoReducer from "containers/MarketplaceDemo/reducer";
import * as consultingProjectsReducer from "containers/ConsultingProjects/reducer";
import { getUserID, getUserName } from "containers/Login/reducer";
import ConsultingProjects from "components/ConsultingProjects/ConsultingProjects";
import * as setupReducer from "containers/Setup/reducer";
import * as createReducer from "containers/CreateWizard/reducer";

class ConsultingProjectsContainer extends React.PureComponent {
  componentDidMount() {
    const { clearProject } = this.props;
    clearProject();
  }

  render() {
    const { userId } = this.props;
    return <ConsultingProjects isAuthor={(id) => parseInt(id) === userId} {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateConsultingPost: (id, consulting) => dispatch(marketplaceDemoReducer.updateConsultingPost(id, consulting)),
  getConsultingBPs: (bps) => dispatch(marketplaceDemoReducer.getConsultingBPs(bps)),
  getConsultingData: (data) => dispatch(marketplaceDemoReducer.getConsultingData(data)),
  getConsultingPost: (id) => dispatch(marketplaceDemoReducer.getConsultingPost(id)),
  cancelConsultingProject: (id) => dispatch(consultingProjectsReducer.cancelConsultingProject(id)),
  progressConsultingProject: (id, newStatus) =>
    dispatch(consultingProjectsReducer.progressConsultingProject(id, newStatus)),
  getBlueprintData: (id) => dispatch(consultingProjectsReducer.getBlueprintDataset(id)),

  updateStep: (step) => dispatch(createReducer.updateStep(step)),
  updateDatasetId: (datasetId) => dispatch(setupReducer.updateDatasetId("new", datasetId)),

  selectProject: (id) => dispatch(consultingProjectsReducer.selectProject(id)),
  clearProject: () => dispatch(consultingProjectsReducer.clearProject()),

  limitData: () => dispatch(consultingProjectsReducer.updateCreatingProject(true))
});

const mapStateToProps = (state) => ({
  consulting: marketplaceDemoReducer.getConsulting(state),
  userId: getUserID(state),
  userName: getUserName(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ConsultingProjectsContainer);
